<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="shopName" slot-scope="{row}">
          <template v-if="row.shop">
            <el-button class="black" type="text" @click="$router.push({path: '/shop/list', query: {shop_id: row.shop_id}})">
              {{row.shop.name}}
            </el-button>
          </template>
          <template v-else>-</template>
        </template>
        <template slot="amount" slot-scope="scope">
          <span>{{formatAmount(scope.row)}}</span>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  export default {
    name: "BuyRecord",
    mixins: [PagingData],
    components: {Statistics},
    data() {
      return {
        // 统计
        countList: [
          {name: "购买总数", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "商家名称", property: "shopName"},
            {label: "购买时间", property: "create_at", width: 140},
            {label: "订单编号", property: "order_no"},
            {label: "总金额(￥)", property: "amount", width: 90},
            {label: "描述", property: "describe"},
            {label: "操作员", property: "merchant.username"},
          ],
        },
      }
    },
    methods: {
      /**格式化*/
      formatAmount(row) {
        return this.convertYuan(row.amount);
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize,
        };
        let res = await this.$Http.getSmsBuyList(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      },
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
